import React from 'react'
import { Box, Grid, Heading, useTheme } from '@chakra-ui/react'
import { gql } from '@urql/core'
import { isServerSide } from 'lib/env'
import useQuery from 'hooks/useQuery'
import {
    FRAGMENT_JOB_MINI_CARD,
    JobMiniCard,
    JobMiniCardData,
} from 'components/job/JobMiniCard'

const QUERY_RELATED_JOBS = gql<{ jobs: JobMiniCardData[] }, { jobId: string }>`
    query related_jobs($jobId: ID!) {
        jobs(
            filter_type: "recommended"
            entity_type: "job"
            entity_id: $jobId
            page_size: 3
            page_number: 1
        ) {
            ...JobMiniCard
        }
    }
    ${FRAGMENT_JOB_MINI_CARD}
`

export const RelatedJobsInner = ({ jobs }: { jobs: JobMiniCardData[] }) => {
    const { cardSizes } = useTheme()
    const isLoaded = jobs.some(j => j.id)

    return (
        <Box>
            <Heading size="sm" mb={{ base: '16px', md: '24px' }}>
                Similar roles that might interest you
            </Heading>
            <Grid
                templateColumns={{
                    base: '100%',
                    sm: `repeat(auto-fill, minmax(${cardSizes.sm}, 1fr))`,
                }}
                gridGap={{ base: '16px', lg: '24px' }}
            >
                {[0, 1, 2].map(idx => {
                    if (!isLoaded) {
                        return <JobMiniCard key={idx} />
                    } else if (jobs[idx]) {
                        return <JobMiniCard job={jobs[idx]} key={jobs[idx].id} />
                    }
                    return null
                })}
            </Grid>
        </Box>
    )
}

export const RelatedJobs = ({ jobId }: { jobId: string }) => {
    const [jobsResult] = useQuery({
        query: QUERY_RELATED_JOBS,
        variables: {
            jobId,
        },
        pause: isServerSide || !jobId,
    })

    return <RelatedJobsInner jobs={jobsResult.data?.jobs ?? []} />
}
